import type { Viewer } from '../../../../viewer';
import { FilletCommandAdapter } from '../../../command/fillet/FilletCommandAdapter';
import type { FilletFeatureDefinitionModel } from '../../../definition/fillet/FilletFeatureDefinition';
import type { FeatureEditSession } from '../../../edit/FeatureEditSession';
import type { FilletFeaturePrototype } from '../../../prototype/fillet/FilletFeaturePrototype';
import type { FeatureExecutionRuntime } from '../../FeatureExecutionRuntime';
import { FeatureCommitExecution } from '../FeatureCommitExecution';

/**
 * 圆角特征正式提交执行器。
 */
export class FilletCommitExecution extends FeatureCommitExecution<
    FilletFeatureDefinitionModel,
    FilletFeaturePrototype
> {
    /** 执行运行时。 */
    private readonly runtime: FeatureExecutionRuntime;
    /** 替换命令通道。 */
    private readonly replaceFeatureCommand: (featureId: string, command: CadCommand) => Promise<boolean>;
    /** 命令适配器。 */
    private readonly adapter: FilletCommandAdapter;

    /**
     * @param _viewer Viewer 实例。
     * @param runtime 执行运行时。
     * @param replaceFeatureCommand 替换命令回调。
     */
    public constructor(
        _viewer: Viewer,
        runtime: FeatureExecutionRuntime,
        replaceFeatureCommand: (featureId: string, command: CadCommand) => Promise<boolean>,
    ) {
        super();
        this.runtime = runtime;
        this.replaceFeatureCommand = replaceFeatureCommand;
        this.adapter = new FilletCommandAdapter();
    }

    /**
     * @inheritdoc
     */
    public async commitCreate(prototype: FilletFeaturePrototype): Promise<string> {
        const command = this.adapter.createCommandFromPrototype({
            prototype,
            clientId: 'web-client',
        }) as CadCommand;
        const result = await this.runtime.executeCommand(command);
        return result.objectId;
    }

    /**
     * @inheritdoc
     */
    public async commitEdit(
        session: FeatureEditSession<FilletFeatureDefinitionModel, FilletFeaturePrototype>,
        prototype: FilletFeaturePrototype,
    ): Promise<boolean> {
        const command = this.adapter.createCommandFromPrototype({
            prototype,
            clientId: 'web-client',
        }) as CadCommand;
        return this.replaceFeatureCommand(session.getPrototype().getFeatureId(), command);
    }
}
